import { ReactNode, createContext, useContext } from 'react'

/**
 * Prefix prepended to the ids of rich-text headings rendered inside it.
 *
 * Each accordion item renders its own rich text, and headings are only de-duplicated within one
 * rich text, so the same heading in two items ("Marking guidelines") would otherwise get the same
 * id — and the same copy-URL anchor.
 */
export const HeadingIdPrefixContext = createContext('')

export const useHeadingIdPrefix = () => useContext(HeadingIdPrefixContext)

export const HeadingIdPrefixProvider = ({
	prefix,
	children,
}: {
	prefix: string
	children: ReactNode
}) => {
	// Compose with an outer provider so a nested accordion is still unique
	const outerPrefix = useHeadingIdPrefix()
	const value = [outerPrefix, prefix].filter(Boolean).join('-')

	return (
		<HeadingIdPrefixContext.Provider value={value}>
			{children}
		</HeadingIdPrefixContext.Provider>
	)
}
